import listComponent from '@/util/proto/listComponent'
import { onlineRate } from './'

export default {
  extends: listComponent,

  data() {
    return {
      columns: [
        {
          title: '序号',
          type: 'index',
          align:'center',
          width: 60,
        },
        {
          title: '网点名称',
          key: 'companyName',
          minWidth: 150,
        },
        {
          title: '车辆总数',
          key: 'carTotal',
          minWidth: 100,
        },
        {
          title: '工作总数',
          key: 'carWorkNum',
          minWidth: 100,
        },
        {
          title: '休息车辆',
          key: 'carRestNum',
          minWidth: 100,
        },
        {
          title: '工作效率',
          key: 'onlineRate',
          minWidth: 100,
        },
      ],
      data: [],
      options:{},
      visible:false,
    }
  },


  methods: {

    init(options) {
      this.options = options
      this.visible = true
      this.search()
    },
    search(){

      let params = { search:this.options || {}, pageSize: this.page.pageSize, pageNum: this.page.pageNum , orders:this.page.orders }
      this.loading = true

      this.$request.statsBrand(params).then(resp => {
        this.loading = false
        this.data = this.$utils.conv(resp.data.list || [] , {createDatetime:'datetime',warnLevel:'companyWarningStrategy',onlineRate})
        this.page.total = resp.data.total
      })
    },
  },

  render(){
    const data = this.data || {}

    const title = '品牌经营信息'
    return (
      <sl-side-panel v-model={this.visible} mask-closable={false} title={title}>
        <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} />

      </sl-side-panel>
    )
  }
}
